/** @format */

const EN_MESSAGE = {
  'login.error': 'Login false'
};

export default EN_MESSAGE;
